import codes from '@/f1/codes'
import { api, signalr } from '@/f1/service'
import { Switch as cSwitch } from '@coreui/vue';
import Language from './language';
import agent from '../../agent/service'

//restful api
// import { wsfinder as wf } from '@/f1/service/api';

const _i18n_data = {
  saved: {
    EN : `saved`,
    KO : `저장되었습니다`,
    JP : `saved`,
  },
  updated: {
    EN : `updated`,
    KO : `업데이트되었습니다`,
    JP : `updated`,
  },
};

export default {
  computed : {
    i18n_data() { return _i18n_data; },
  },
  components: { cSwitch, Language },
	data : () => { return { lock : false, codes : codes, model : {} } },
  methods: {
    is_valid() {
      if(!(this.model.type || '')) { return this.$toastr.e('type are required'); }
      if(!(this.model.ext || '')) { return this.$toastr.e('ext are required'); }
      if(!(this.model.category || '')) { return this.$toastr.e('category are required'); }
      if(!(this.model.code || '')) { return this.$toastr.e('code are required'); }
      if(this.model.is_alive == undefined) { return this.$toastr.e('is_alive are required'); }

      // vaildate RegExp (Task #1921)
      if(this.model.type == '1') { // 1 = Regex
        let pattern = '/' + this.model.code + '/';
        let flag = '';
        let re = (function(o, p, f) {
          try {
            return new RegExp(p, f);
          } catch(e) {
            return o.$toastr.e(e.message);
          }
        })(this, pattern, flag);

        if(re instanceof RegExp) {
          this.$toastr.s("Vaild expression: " + pattern);
        } else {
          return this.$toastr.e("No vaild expression");
        }
      }
    },
    async test() {
      this.is_valid()
      try {
        agent.ws.Cmd("pattern_user_test", `${this.model.id}`).then(rs => this.response_handler(rs))
        let rs = await api.wsfinder.WSFinder_Call('pattern', 'test', this.model)
        //let rs = await wf.pattern.test(this.modal)
        if(rs.error) { return this.$toastr.e("load failed") }

        this.$toastr.s('request testing');
        this.$emit('refresh');
      } catch(e) { this.$toastr.e(e.data ? e.data.message : e.statusText) ; }
    },
    cancel: function() { this.$router.replace({ name: 'wsfinder_pattern', params: { id: this.model.id}}); },
    list: function() { this.$router.push({ name: 'wsfinder_pattern'}); },
    async save() {

      this.is_valid()

      try {
        let rs = await api.wsfinder.WSFinder_Call('pattern', this.model.id ? 'update' : 'insert', this.model)

        // let check_id = this.model.id ? `${await wf.pattern.update(this.model)}` : `${await wf.pattern.insert(this.model)}`
        // let rs = check_id

        if(rs.error) { return this.$toastr.e("load failed") }
        this.$toastr.s(this.i18n_data['saved'][this.i18n]); this.$emit('refresh'); this.list();
        return;
      } catch(e) { this.$toastr.e(e.data ? e.data.message : e.statusText) ; }
    },
    async get(id = this.$route.params.id) {
      console.log('pattern.edit.vue', 'load item', id);
      if(id !== 'add') {
        try {
          let rs = await api.wsfinder.WSFinder_Call('pattern', 'detail', {id : id});
          //let rs = await wf.pattern.detail({id : id});
          this.model = Object.assign({}, this.model, rs.body);

          // 점검 부분
          agent.ws.Cmd("status", `${this.model.id}`).then(rs => this.response_handler(rs))

        } catch(e) { this.$toastr.e(e.data ? e.data.message : e.statusText) ,this.cancel(); }
      }
    },
    res_msg(pl, cmd) {

    },
    async response_handler(m) {
      // console.info(m)
      if((!m.body && !m.cmd && m.cmd != 'list') || m.agent_id != this.model.id) { return;  }
      let pl = m.body;

      if(pl && pl.error) { this.$toastr.e(pl.reason, `${m.cmd} failed`); return 'error'; }
      else if(m.cmd == "status" || m.cmd == "pong") { return m.cmd; }
      else { this.$toastr.s(`${m.cmd} done`); return m.cmd }
    },
  },
  watch: { '$route' (to, from) { this.get(to.params.id); } },
  created: function() { console.log('pattern.edit.vue', 'created'); },
  destroyed: function() {
    signalr.off('wsfinder_response', this.response_handler);
    console.log('pattern.edit.vue', 'destroyed');
  },
  mounted: function() {
    console.log('pattern.edit.vue', 'mounted');
    this.get(this.$route.params.id);
    signalr.on('wsfinder_response', this.response_handler);
  }
}
